import React from 'react';

const COLOR_NAMES = { R: 'Feuriges Rot', Y: 'Sonniges Gelb', G: 'Erdiges Grün', B: 'Kühles Blau' };
const COLOR_HEX   = { R: '#B82D14', Y: '#9A6E00', G: '#165C38', B: '#0F3068' };
const COLOR_LIGHT = { R: '#FFF0EC', Y: '#FFF8E0', G: '#E6F4EE', B: '#E6EDF8' };

export function ColorBadge({ color, size = 'md' }) {
  if (!color) return <span style={{ color: '#888', fontSize: '0.82rem' }}>—</span>;
  const s = size === 'sm' ? { padding: '3px 10px', fontSize: '0.78rem' } : {};
  return (
    <span className={`color-badge badge-${color}`} style={s}>
      <span className={`color-dot dot-${color}`} />
      {COLOR_NAMES[color]}
    </span>
  );
}

export function ScoreBars({ avgR, avgY, avgG, avgB }) {
  const vals = [['R', avgR], ['Y', avgY], ['G', avgG], ['B', avgB]];
  const sorted = [...vals].sort((a, b) => b[1] - a[1]);
  return (
    <div className="score-bars">
      {sorted.map(([c, v]) => (
        <div key={c} className="score-bar-row">
          <span className="score-bar-label">{COLOR_NAMES[c]}</span>
          <div className="score-bar-track">
            <div className="score-bar-fill" style={{ width: `${(v / 6) * 100}%`, background: COLOR_HEX[c] }} />
          </div>
          <span className="score-bar-num">{Number(v).toFixed(2)}</span>
        </div>
      ))}
    </div>
  );
}

export function ProfileCard({ profile, title = 'Profil', peerName }) {
  if (!profile) return null;
  return (
    <div style={{ background: COLOR_LIGHT[profile.dominant_color], border: `2px solid ${COLOR_HEX[profile.dominant_color]}40`, borderRadius: 10, padding: '16px 20px', marginBottom: 12 }}>
      {peerName && <div style={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#555', marginBottom: 4 }}>Einschätzung von {peerName}</div>}
      <div style={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#555', marginBottom: 8 }}>{title}</div>
      <ColorBadge color={profile.dominant_color} />
      <ScoreBars avgR={profile.avg_r} avgY={profile.avg_y} avgG={profile.avg_g} avgB={profile.avg_b} />
      {profile.completed_at && (
        <div style={{ fontSize: '0.75rem', color: '#777', marginTop: 8 }}>
          {new Date(profile.completed_at).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })}
        </div>
      )}
    </div>
  );
}

export { COLOR_NAMES, COLOR_HEX };
